module.exports = __webpack_public_path__ + "0e1136f449604c9adf325914cbd60844.svg";